"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("../../../../utils");
// Adds extension to file name
function addExtension(fileName, file) {
  var rootName = (0, _utils.first)(fileName.split('.'));
  var extension = (0, _utils.last)(file.name.split('.'));
  return "".concat(rootName, ".").concat(extension);
}
var _default = addExtension;
exports["default"] = _default;